import { render } from "./GeneralInfo.vue?vue&type=template&id=1d9450ac"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"

import "./GeneralInfo.vue?vue&type=style&index=0&id=1d9450ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__